module.exports = __webpack_public_path__ + "img/nedvij.44535a17.png";